export const REMIX_UI_STYLE_LAYER = 'rmx';
export const REMIX_UI_RESET_LAYER = 'rmx-reset';
//# sourceMappingURL=layers.js.map